declare namespace $ {

	export class $mol_icon_bell extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=bell.view.tree.d.ts.map